import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserContext } from '../../context/UserContext';

const RequireAuth = ({ children }) => {
    const { token } = useUserContext();
    const location = useLocation();

    if (!token) {
        return <Navigate to="/signin" state={{ from: location }} replace />;
    }

    return children;
};

export default RequireAuth;
